import { render } from "./Section4.vue?vue&type=template&id=82f97d10&scoped=true"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"

import "./Section4.vue?vue&type=style&index=0&id=82f97d10&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f97d10"]])

export default __exports__